export default function ProductsFooter() {
	return (
		<p className="small mt-3 mb-0 text-muted">
			We use Stripe as our payment solution for seamless and secure transactions. <br />
			All purchases will be processed through the{' '}
			<a
				href="https://stripe.com/"
				target="_blank"
				rel="noopener noreferrer"
				className="text-muted">
				Stripe platform
			</a>
			.
		</p>
	);
}
